import {
  AgFinancing,
  AgFinancingCollateralAnalysisStatus,
  AgFinancingMatricula,
  AgFinancingMatriculaDetail,
  AgFinancingPhase2Status,
  CollateralType,
  Phase2
} from '@indigo-ag/schema';

export class CollateralUtil {
  static hasBeenApproved(status?: AgFinancingCollateralAnalysisStatus): boolean {
    return status === AgFinancingCollateralAnalysisStatus.APPROVED;
  }

  static hasBeenDenied(status: AgFinancingCollateralAnalysisStatus): boolean {
    return status === AgFinancingCollateralAnalysisStatus.DENIED;
  }

  static hasBeenSent(status?: AgFinancingCollateralAnalysisStatus): boolean {
    return status === AgFinancingCollateralAnalysisStatus.COMPLETED;
  }

  static hasNotBeenSent(status?: AgFinancingCollateralAnalysisStatus): boolean {
    return status === AgFinancingCollateralAnalysisStatus.STARTED;
  }

  static isOnHold(status?: AgFinancingCollateralAnalysisStatus): boolean {
    return status === AgFinancingCollateralAnalysisStatus.ON_HOLD;
  }

  static canOnHoldResume(phaseInfo?: Phase2): boolean {
    return (
      !!phaseInfo?.status &&
      phaseInfo.status === AgFinancingPhase2Status.IN_PROGRESS &&
      !!phaseInfo?.collateral?.status &&
      phaseInfo?.collateral?.status !== AgFinancingCollateralAnalysisStatus.COMPLETED
    );
  }

  static hasStarted(collateral?: Phase2['collateral']): boolean {
    return !!collateral?.startedAt;
  }

  static canStart(
    canStartPhase2: AgFinancing['canStartPhase2'],
    collateralType?: CollateralType,
    phaseInfo?: Phase2
  ): boolean {
    let canStartByCollateralType = false;
    if (collateralType === CollateralType.CPR) {
      canStartByCollateralType = !!phaseInfo?.matriculas?.length;
    } else if (collateralType === CollateralType.PROMISSORY_NOTE) {
      // might have different restrictions in the future.
      canStartByCollateralType = true;
    } else {
      // TODO: if we don't have collateralType we don't want to restrict, for now
      canStartByCollateralType = true;
    }

    return !!canStartPhase2 && canStartByCollateralType;
  }

  static canReopen(phaseInfo?: Phase2): boolean {
    return (
      phaseInfo?.collateral?.status === AgFinancingCollateralAnalysisStatus.COMPLETED &&
      phaseInfo?.status !== AgFinancingPhase2Status.APPROVED &&
      phaseInfo?.status !== AgFinancingPhase2Status.DENIED
    );
  }

  static canEditMatricula(status?: AgFinancingCollateralAnalysisStatus): boolean {
    return status === AgFinancingCollateralAnalysisStatus.STARTED;
  }

  static hasRegistrationNumber(matriculaDetail: AgFinancingMatriculaDetail): boolean {
    return !!matriculaDetail.registrationNumbers;
  }

  static hasCultivableArea(matriculaDetail: AgFinancingMatriculaDetail): boolean {
    return (matriculaDetail.cultivableArea ?? 0) > 0;
  }

  static isFormalizationComplete(agFinancing: AgFinancing): boolean {
    return !agFinancing.phase2 || agFinancing.phase2.status !== AgFinancingPhase2Status.APPROVED;
  }

  static filterMatriculasForDetails(
    matriculas: AgFinancingMatricula[],
    includedInFormalization: boolean
  ): AgFinancingMatricula[] {
    return matriculas.filter(
      m =>
        (includedInFormalization ? m.includedInFormalization : m.includedInAnalysis) &&
        m.details?.find(m => CollateralUtil.hasRegistrationNumber(m)) &&
        m.details?.find(m => CollateralUtil.hasCultivableArea(m))
    );
  }
}
